<template>
  <!-- 25.6.5 共用标题 dxm -->
  <div class="title_wrap">
    <!-- type 1 首页标题 2 二级页面标题 3 二级页面标题带图标 -->
    <div class="title" v-if="type == 1">
      {{ title }}
    </div>
    <div class="title_second" v-if="type == 2">
      {{ title }}
    </div>
    <div class="title_second flex flex_items_center" v-if="type == 3">
      <img :src="require('../assets/imgs/title_img.jpg')" alt="">  {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    type: Number,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss">
.title_wrap {
  .title {
    color: #000;
    font-size: 40px;
    font-weight: 500;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      bottom: -4px;
      left: 0;
      width: 180px;
      height: 10px;
      z-index: -1;
      background: #e62344;
    }
  }
  .title_second {
    color: #000;
    font-size: 30px;
    font-weight: 500;
    position: relative;
    padding-bottom: 6px;
    border-bottom: 1px solid #004190;
    &::before {
      content: "";
      position: absolute;
      bottom: -1px;
      left: 0;
      width: 180px;
      height: 5px;
      z-index: 2;
      background: #e62344;
    }
    img{
      width: 40px;
      margin-right: 10px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .title_wrap {
    .title {
      font-size: 34px;
    }
  }
}
@media only screen and (max-width: 767px) {
  .title_wrap {
    .title {
      font-size: 0.35rem;
      &::before {
        width: 1.54rem;
        height: 0.1rem;
        bottom: -1px;
      }
    }
    .title_second{
      font-size: 0.35rem;
      &::before {
        width: 1.54rem;
        height: 0.1rem;
        bottom: -1px;
      }
    }
  }
}
.main_partners{
  .title_wrap{
    .title{
      text-align: center;
      &::before{
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>